export default __webpack_public_path__ + "static/discover-the-aurora-borealis-on-your-next-holiday-iceland-c7e41ef145530ec46f7c5ac2ec1b04a8.jpg";